module.exports = __webpack_public_path__ + "img/Freeze Icon - white.9f71a3a5.svg";